const CLOUDPAYMENTS_SCRIPT_URL = 'https://widget.cloudpayments.ru/bundles/cloudpayments.js'
let cloudPaymentsScriptPromise: Promise<void> | null = null

export const loadCloudPaymentsScript = () => {
    if (typeof window === 'undefined') {
        return Promise.resolve()
    }
    if (window.cp?.CloudPayments) {
        return Promise.resolve()
    }
    if (cloudPaymentsScriptPromise) {
        return cloudPaymentsScriptPromise
    }

    cloudPaymentsScriptPromise = new Promise((resolve, reject) => {
        const existingScript = document.querySelector(
            `script[src="${CLOUDPAYMENTS_SCRIPT_URL}"]`
        ) as HTMLScriptElement | null
        if (existingScript) {
            const handleLoad = () => resolve()
            const handleError = () => reject(new Error('CloudPayments script load error'))
            existingScript.addEventListener('load', handleLoad, { once: true })
            existingScript.addEventListener('error', handleError, { once: true })
            return
        }

        const script = document.createElement('script')
        script.src = CLOUDPAYMENTS_SCRIPT_URL
        script.async = true
        script.addEventListener('load', () => resolve(), { once: true })
        script.addEventListener('error', () => reject(new Error('CloudPayments script load error')), {
            once: true,
        })
        document.body.appendChild(script)
    })

    return cloudPaymentsScriptPromise
}
